import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
    const storedActive = localStorage.getItem('active');
    const [active, setActive] = React.useState(storedActive || "name-converter");

    useEffect(() => {
        // Update localStorage when the active state changes
        localStorage.setItem('active', active);
    }, [active]);

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "space-around",
                padding: "1rem",
            }}
        >
            <Link
                style={{
                    textDecoration: "none",
                    color: "white"
                }}
                to="/"
            >
                <div
                    style={{
                        fontSize: "2rem",
                        fontWeight: "bold",
                        background: active === "name-converter" ? "#dc3545" : "grey",
                        padding: "0.5rem 1rem",
                        borderRadius: "10px",
                        cursor: "pointer",
                    }}
                    onClick={() => setActive("name-converter")}
                >
                    Name Converter
                </div>
            </Link>

            <Link
                style={{
                    textDecoration: "none",
                    color: "white"
                }}
                to="/workflow"
            >
                <div
                    style={{
                        fontSize: "2rem",
                        fontWeight: "bold",
                        background: active === "work-flow" ? "#dc3545" : "grey",
                        color: "white",
                        padding: "0.5rem 1rem",
                        borderRadius: "10px",
                        cursor: "pointer"
                    }}
                    onClick={() => setActive("work-flow")}
                >
                    Work Flow
                </div>
            </Link>

            <Link
                style={{
                    textDecoration: "none",
                    color: "white"
                }}
                to="/extra-points"
            >
                <div
                    style={{
                        fontSize: "2rem",
                        fontWeight: "bold",
                        background: active === "extra-points" ? "#dc3545" : "grey",
                        color: "white",
                        padding: "0.5rem 1rem",
                        borderRadius: "10px",
                        cursor: "pointer"
                    }}
                    onClick={() => setActive("extra-points")}
                >
                    Extra Points
                </div>
            </Link>

        </div>
    );
}

export default Navbar;
